import ReactGA4 from 'react-ga4';

type Props = {
  category: 'click' | 'backend' | 'input';
  action: string;
  label: 'registration' | 'trade';
};

const logEvent = ({ action, category, label }: Props) => {
  ReactGA4.event({
    category,
    action,
    label,
  });
};

export default logEvent;
